import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Drawer, List, Icon, Button, Select, MenuItem } from '@material-ui/core';
import { ListItem, Typography } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GroupsIcon from '@mui/icons-material/Groups';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';
import AddIcon from '@mui/icons-material/Add';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import { SIDE_BAR_Z_INDEX, exchangeRates } from 'src/const';
// import logo from '../../assets/logo.svg';
import logo from '../../assets/logoMobile.jpg';
// import logoMini from '../../assets/logoMini.svg';
import logoMini from '../../assets/logoMobileSidebarCollapsed.jpg';
import leftArrow1 from '../../assets/leftArrow1.svg';
import rightArrow1 from '../../assets/rightArrow1.svg';
import { SidebarProps } from 'src/interfaces/iproptypes';
import { SidebarItemType } from 'src/interfaces/idashboard';
import useStyles from './styles';
import SidebarItem from './SidebarItem';
import { Box, IconButton, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CalculateIcon from '@mui/icons-material/Calculate';
import InsightsIcon from '@mui/icons-material/Insights';
import ClickAwayListener from '@mui/base/ClickAwayListener';

import {
  COLOR_BACKGROUND_1,
  COLOR_TERTIARY_1_100,
  COLOR_TERTIARY_1_200,
  COLOR_TERTIARY_1_400,
} from 'src/colors';
import { InfoTooltip } from '../Tooltips';
import { TooltipCard } from '../Cards';
import CurrencyChangeMenu from '../CurrencyChangeMenu';
const sideBarIconStyle = { fontSize: 25, color: '#000', padding: '2 0' };

//sidebar hierarchy data
// const sidebarItems: SidebarItemType[] = [
//   {
//     name: 'Find Market',
//     icon: <TravelExploreRoundedIcon style={sideBarIconStyle} />,
//     isPage: false,
//     stateName: '',
//     listIndex: NaN,
//     children: [
//       {
//         name: 'Search Market',
//         isPage: true,
//         stateName: 'addMarket',
//         listIndex: 12,
//       },
//       {
//         name: 'Draw Custom Market',
//         isPage: true,
//         stateName: 'tailoredRegion',
//         // stateName: '',
//         listIndex: 11,
//       },
//       {
//         name: 'Discovery',
//         isPage: true,
//         stateName: 'discovery',
//         listIndex: 6,
//         chipLabel: 'Pro',
//       },
//       {
//         name: 'Saved Markets',
//         isPage: true,
//         stateName: 'settings',
//         listIndex: 10,
//       },
//     ],
//   },
//   {
//     name: 'Invest',
//     icon: <AccountBalanceWalletIcon style={sideBarIconStyle} />,
//     isPage: false,
//     stateName: '',
//     listIndex: NaN,
//     children: [
//       {
//         name: 'Overview',
//         isPage: true,
//         stateName: 'main',
//         listIndex: 0,
//       },
//       {
//         name: 'Calculate ROI',
//         isPage: true,
//         stateName: 'estimator',
//         listIndex: 1,
//       },
//       {
//         name: 'My Analysis',
//         isPage: true,
//         stateName: 'myAnalysis',
//         listIndex: 5,
//       },
//       {
//         name: 'Guests',
//         isPage: true,
//         stateName: 'guests',
//         listIndex: 4,
//       },
//       // {
//       //   name: 'Historical',
//       //   isPage: true,
//       //   stateName: 'historical',
//       //   listIndex: 8,
//       // },
//       // {
//       //   name: 'Airbtics Pro',
//       //   isPage: true,
//       //   stateName: 'airbticsPro',
//       //   listIndex: 9,
//       // }
//     ],
//   },
//   {
//     name: 'Manage',
//     icon: <GroupsIcon style={sideBarIconStyle} />,
//     isPage: false,
//     stateName: '',
//     listIndex: NaN,
//     children: [
//       {
//         name: 'Dynamic Pricing',
//         isPage: true,
//         stateName: 'listings',
//         listIndex: 7,
//         chipLabel: 'Beta',
//       },
//       {
//         name: 'CompSet',
//         isPage: true,
//         stateName: 'pricing',
//         listIndex: 3,
//       },
//     ],
//   },
//   {
//     name: 'Enterprise',
//     icon: <BusinessRoundedIcon style={sideBarIconStyle} />,
//     isPage: false,
//     stateName: '',
//     listIndex: NaN,
//     children: [
//       {
//         name: 'Custom Data',
//         isPage: true,
//         stateName: 'enterprise',
//         listIndex: NaN,
//         redirectionLink: 'https://wll5z0jqe4c.typeform.com/to/t9O80SZ2',
//       },
//       {
//         name: 'API',
//         isPage: true,
//         stateName: 'api',
//         listIndex: NaN,
//         redirectionLink: 'https://documenter.getpostman.com/view/25155751/2s9XxtyvNn',
//       },
//     ],
//   },
// ];

// main component

const sidebarItems: SidebarItemType[] = [
  {
    icon: <InsightsIcon style={sideBarIconStyle} />,
    name: 'Overview',
    isPage: false,
    stateName: 'main',
    listIndex: 0,
    children: [],
  },
  {
    icon: <CalculateIcon style={sideBarIconStyle} />,
    name: 'Calculate ROI',
    isPage: false,
    stateName: 'estimator',
    listIndex: 1,
    children: [
      {
        name: 'Saved Analyses',
        isPage: true,
        stateName: 'myAnalysis',
        listIndex: 5,
      },
    ],
  },
  // {
  //   icon: <AccountBalanceWalletIcon style={sideBarIconStyle} />,
  //   name: 'Saved Analyses',
  //   isPage: false,
  //   stateName: 'myAnalysis',
  //   listIndex: 5,
  //   children: [],
  // },
  // {
  //   name: 'Manage',
  //   icon: <GroupsIcon style={sideBarIconStyle} />,
  //   isPage: false,
  //   stateName: '',
  //   listIndex: NaN,
  //   children: [
  //     {
  //       name: 'Dynamic Pricing',
  //       isPage: true,
  //       stateName: 'listings',
  //       listIndex: 7,
  //       chipLabel: 'Beta',
  //     },
  //     // {
  //     //   name: 'CompSet',
  //     //   isPage: true,
  //     //   stateName: 'pricing',
  //     //   listIndex: 3,
  //     // },
  //   ],
  // },
  // {
  //   name: 'Enterprise',
  //   icon: <BusinessRoundedIcon style={sideBarIconStyle} />,
  //   isPage: false,
  //   stateName: '',
  //   listIndex: NaN,
  //   children: [
  //     {
  //       name: 'Custom Data',
  //       isPage: true,
  //       stateName: 'enterprise',
  //       listIndex: NaN,
  //       redirectionLink: 'https://wll5z0jqe4c.typeform.com/to/t9O80SZ2',
  //     },
  //     {
  //       name: 'API',
  //       isPage: true,
  //       stateName: 'api',
  //       listIndex: NaN,
  //       redirectionLink: 'https://documenter.getpostman.com/view/25155751/2s9XxtyvNn',
  //     },
  //   ],
  // },
];

const Sidebar = ({
  parent,
  handleSidebarClick,
  sidebarOpen,
  setSidebarOpen,
  matches,
  selectedSidebarIndex,
  handleSidebarListItemClick,
  currency,
  setCurrency,
  isUserVerified,
  setIsEmailVerifyModalOpen,
  showAppTour,
  dashboardState,
  setSubscriptionModalOpen,
  user,
}: SidebarProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [sideBarReadyToCollapse, setSideBarReadyToCollapse] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setSideBarReadyToCollapse(sidebarOpen);
    }, 500);
  }, [sidebarOpen]);

  useEffect(() => {
    if (window.innerWidth < 1050) {
      setSidebarOpen(false);
    }
  }, [matches]);

  const changeCurrency = (
    event: React.ChangeEvent<{
      name?: string;
      value: unknown;
    }>
  ) => {
    setCurrency(event.target.value);
  };

  const currentPath = window.location.pathname;
  const isLandingPage = currentPath === '/';

  const isTopBannerOpen = useSelector((state: any) => state.dashboard.isTopBannerOpen);

  const handleClickAway = () => {
    if (matches && sideBarReadyToCollapse) {
      setSidebarOpen(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.paperDrawer, {
            [classes.drawerOpen]: sidebarOpen,
            [classes.drawerClose]: !sidebarOpen,
            [classes.bannerOpen]: isTopBannerOpen,
          }),
        }}
        className="sidebar-scroll"
      >
        {/* Button */}
        {sidebarOpen ? (
          <Icon
            className={classes.switch}
            aria-label="open drawer"
            onClick={() => setSidebarOpen(false)}
          >
            <img src={leftArrow1} />
          </Icon>
        ) : (
          <Icon
            className={classes.switchClosed}
            aria-label="open drawer"
            onClick={() => setSidebarOpen(true)}
          >
            <img src={rightArrow1} />
          </Icon>
        )}

        <Button
          className={classes.logoButton}
          onClick={() => {
            if (handleSidebarClick) handleSidebarClick('');
            handleSidebarListItemClick(-1);
            //directs to home page tab
            history.push('/');
          }}
        >
          {sidebarOpen ? (
            <img src={logo} className={classes.logo} />
          ) : (
            <img src={logoMini} className={classes.logoMini} />
          )}
        </Button>

        {/* Dashboard */}
        <div>
          {/* {sidebarOpen && (
            <div
              id="creditsBtn"
              style={{
                height: '30px',
                width: '90%',
                backgroundColor: COLOR_TERTIARY_1_100,
                marginLeft: '15px',
                borderRadius: '10px',
              }}
            >
              <Typography variant="body1">
                <InfoTooltip
                  title={
                    <TooltipCard
                      content={
                        dashboardState.showEstimatorDashboard
                          ? 'Access full comps and data for an address using 1 estimator credit.'
                          : 'It gives access to one market dashboard per credit.'
                      }
                    />
                  }
                >
                  <Box sx={{ paddingLeft: 1, paddingTop: '2.5px' }}>
                    <Typography variant="body1">
                      {dashboardState.showEstimatorDashboard ? 'Estimator' : 'Market'} Credits:{' '}
                      {dashboardState.showEstimatorDashboard ? user.estimatorCredits : user.credits}
                      {'   '}
                      <IconButton
                        onClick={() => {
                          setSubscriptionModalOpen(true);
                        }}
                        sx={{
                          backgroundColor: COLOR_BACKGROUND_1,
                          height: 20,
                          width: 20,
                          '&:hover': { backgroundColor: COLOR_BACKGROUND_1 },
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </Typography>
                  </Box>
                </InfoTooltip>
              </Typography>
            </div>
          )} */}
          {sidebarItems.map((data, index) => {
            return (
              <SidebarItem
                item={data}
                isSubGroup={false}
                handleSidebarClick={handleSidebarClick}
                handleSidebarListItemClick={handleSidebarListItemClick}
                matches={matches}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                index={index}
                selectedSidebarIndex={selectedSidebarIndex}
                showAppTour={showAppTour}
                user={user}
              />
            );
          })}
        </div>

        {/* Email verification button */}
        {isUserVerified === false && (
          <List
            disablePadding={false}
            style={{
              position: 'relative',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '20px',
            }}
            onClick={() => setIsEmailVerifyModalOpen(true)}
          >
            <ListItemButton
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                color: '#fff',
                width: '155px',
                animation: 'bounce-up 3.5s 5s ease-in-out infinite',
              }}
            >
              <Stack direction="row" justifyContent="center" alignItems="center" gap={1}>
                <MarkEmailUnreadIcon
                  style={{
                    color: '#fff',
                    animation: 'shake-up-down 3.5s 5s ease-in-out infinite',
                  }}
                />
                {sidebarOpen && (
                  <Typography variant="body1" style={{ marginLeft: 0 }}>
                    Verify Email
                  </Typography>
                )}
              </Stack>
            </ListItemButton>
          </List>
        )}

        {matches && currency && (
          <List
            disablePadding={true}
            style={{
              position: 'relative',
              cursor: 'pointer',
              width: '100%',
              marginBottom: '20px',
            }}
          >
            <ListItem sx={{ paddingLeft: 0 }}>
              <CurrencyChangeMenu
                currency={currency}
                setCurrency={setCurrency}
                fullWidth={true}
                darkTheme={true}
              />
            </ListItem>
          </List>
        )}
      </Drawer>
    </ClickAwayListener>
  );
};

export default Sidebar;
